import OrderConfirmationScreen from './OrderConfirmationScreen';
import OrderPaymentScreen from './OrderPaymentScreen';

export default {
  OrderConfirmationScreen,
  OrderPaymentScreen,
};
